import { c as _c } from "react/compiler-runtime";
import { Drawer } from "@flat-ui";
/**
 * SidePanel component renders a customizable sidebar.
 *
 * Key Features and Usage:
 * - Visibility Control: The `isOpen` prop determines whether the sidebar is open (`true`) or
 *   closed (`false`).
 *
 * - Flexible Positioning: The `anchor` prop specifies the position of the sidebar relative to
 *   the screen. It can be configured as `"left"` (left side), `"right"` (right side),
 *   `"top"` (top of the screen), or `"bottom"` (bottom of the screen), allowing for versatile
 *   interface layouts.
 *
 * - Customizable Content: The `children` prop defines the content to be displayed inside the
 *   sidebar. This can include any valid React elements such as text, interactive components,
 *   forms, or other custom components.
 */
export function SidePanel(t0) {
  const $ = _c(14);
  const {
    isOpen,
    children,
    anchor,
    isDropdownOpened: t1,
    shouldRemoveBackground: t2,
    isBackdropInvisible: t3,
    sx,
    variant: t4,
    closeSidePanel
  } = t0;
  const isDropdownOpened = t1 === undefined ? false : t1;
  const shouldRemoveBackground = t2 === undefined ? false : t2;
  const isBackdropInvisible = t3 === undefined ? false : t3;
  const variant = t4 === undefined ? "temporary" : t4;
  let t5;
  if ($[0] !== closeSidePanel || $[1] !== isDropdownOpened) {
    t5 = function handleSafeClose() {
      if (!isDropdownOpened) {
        closeSidePanel();
      }
    };
    $[0] = closeSidePanel;
    $[1] = isDropdownOpened;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const handleSafeClose = t5;
  let t6;
  if ($[3] !== isBackdropInvisible) {
    t6 = {
      backdrop: {
        invisible: isBackdropInvisible
      }
    };
    $[3] = isBackdropInvisible;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== anchor || $[6] !== children || $[7] !== handleSafeClose || $[8] !== isOpen || $[9] !== shouldRemoveBackground || $[10] !== sx || $[11] !== t6 || $[12] !== variant) {
    t7 = <Drawer hideBackdrop={shouldRemoveBackground} slotProps={t6} anchor={anchor} open={isOpen} variant={variant} component="aside" onClose={handleSafeClose} dataTestId="side-panel-container" sx={sx}>{children}</Drawer>;
    $[5] = anchor;
    $[6] = children;
    $[7] = handleSafeClose;
    $[8] = isOpen;
    $[9] = shouldRemoveBackground;
    $[10] = sx;
    $[11] = t6;
    $[12] = variant;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}